var env = require('./env.js');

function fillModel(scopeUser, n) {
    var model = {};

    if (n===1 || n===5) {
        model.name = scopeUser.name;
        model.email = scopeUser.email;
        model.password = scopeUser.password;
        model.password2 = scopeUser.password2;
        model.n = n;
    }
    if (n===2) {
        model.name = scopeUser.name;
        model.email = scopeUser.email;
        model.password = scopeUser.password;
        model.password2 = scopeUser.password2;
        model.company = scopeUser.company;
        model.n = n;
    }
    if (n===3) {
        model.email = scopeUser.email;
        model.organization = scopeUser.organization;
        model.ogrn = scopeUser.ogrn;
        model.tel = scopeUser.tel;
        model.sport = scopeUser.sport;
        model.region = scopeUser.region;
        model.description = scopeUser.description;
        model.host = window.location.host;
        model.n = n;
    }
    if (n===4) {
        model.email = scopeUser.email;
        model.key = scopeUser.key;
        model.dateBirth = "" + scopeUser.dateBirth.day + "." + scopeUser.dateBirth.month +
        "." + scopeUser.dateBirth.year;
        //model.dateBirth = scopeUser.dateBirth.year + "-" + scopeUser.dateBirth.month +
        //"-" + scopeUser.dateBirth.day;
        model.surname = scopeUser.fio.surname;
        model.name = scopeUser.fio.name;
        model.patronymic = scopeUser.fio.patronymic;
        model.sex = scopeUser.sex;
        model.n = n;
    }
    if (n===40) {
        model.email = scopeUser.email;
        model.key = scopeUser.key;
        model.dateBirth = "" + scopeUser.dateBirth.day + "." + scopeUser.dateBirth.month +
        "." + scopeUser.dateBirth.year;
        model.surname = scopeUser.fio.surname;
        model.name = scopeUser.fio.name;
        model.patronymic = scopeUser.fio.patronymic;
        model.sex = scopeUser.sex;
        model.n = n;
    }
    return model;
}

function register(scopeUser, q, $http, n) {
    var deferred = q.defer();

    var model = fillModel(scopeUser, n);

    var url = env.origin + '/api/user/signup';
    $http.post(url, model).then(function (response) {
        var data = response.data;
        if (data.result)  deferred.resolve(data); else deferred.reject(data);
    });

    return deferred.promise;
}

module.exports = register;


/** WEBPACK FOOTER **
 ** ./_services/registerSvc.js
 **/